<template>
	<span @click="onClick" class="url-button">
		<font-awesome-icon v-if="(crud === 'vds' || crud === 'domains' || crud === 'operation') &&
			(name === 'sshkey_id' || name === 'create_iso' || name === 'person_id' || name === 'payer')"
			icon="plus-circle" />
		{{ text | ftc }}
	</span>	
</template>
<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'urlButton',
	//=========================================================================
	// свойства
	//=========================================================================
	props: ['crud', 'name', 'url', 'text'],
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		onClick(e) {
			// если это переход в создание персоны - нужно сохранить текущую форму
			if (this.url === '/person/create')
			{
				EventBus.$emit('w5-goto-url', this.url)
				return
			}
			this.$router.push(this.url)
		}
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.url-button {
	position: relative;
	font-weight: 500;
    height: 45px;
    line-height: 45px;
    display: inline-block;
    width: auto;
    color: #999;
    cursor: pointer;
    transition: color .2s;
}
.url-button:hover {
    color: #2c8ad8;
}
.w5-application.mc .url-button:hover {
    color: #01196f;
}
.url-button > svg {
	position: relative;
	font-size: 24px;
	top: 3px;
}
.url-button.domains-person-create-button > svg {
	margin-right: 3px;
	font-size: 22px;
}

</style>



// WEBPACK FOOTER //
// urlbtn.vue?2b46326f